module.exports = __webpack_public_path__ + "img/special-sports.c15b6b33.jpg";